// extracted by mini-css-extract-plugin
module.exports = {"container":"e_lk","hoverContainer":"e_mk","tooltip":"e_nk","active":"e_ok","head":"e_pk","text":"e_qk"};